// extracted by mini-css-extract-plugin
module.exports = {"root":"lineup-footer_root__4jwNB","pdfHeading":"lineup-footer_pdfHeading__HITbv"};